<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="auth-wrapper">
  <div class="auth-container">
    <!-- Lado Esquerdo -->
    <div class="auth-side-left">
      <div class="auth-content-left">
        <img src="assets/images/logo/new-logo-cid.png" alt="E-Cidadania" class="logo-img">
        <div class="welcome-text">
          <h1>Bem-vindo a Cidadania Italiana</h1>
          <p>Seu portal de cidadania</p>
        </div>
      </div>
    </div>

    <!-- Lado Direito -->
    <div class="auth-side-right">
      <div class="auth-content-right">

        <h2>Login</h2>
        <form class="login-form">
          <div class="form-group">
            <div class="input-icon">
              <i class="feather icon-mail"></i>
              <input type="email" class="form-control" [(ngModel)]="email" name="email" placeholder="Seu e-mail">
            </div>
          </div>
          <div class="form-group">
            <div class="input-icon">
              <i class="feather icon-lock"></i>
              <input type="password" class="form-control" [(ngModel)]="senha" name="senha" placeholder="Sua senha">
            </div>
          </div>
          <div class="form-group form-group-empresa">
            <label for="idEmpresaLogin">Empresa</label>
            <select
              id="idEmpresaLogin"
              class="form-control select-empresa-login"
              name="idEmpresaLogin"
              [(ngModel)]="idEmpresaSelecionada"
              [disabled]="carregandoEmpresas">
              <option [ngValue]="null" disabled>Selecione a empresa</option>
              <option *ngFor="let e of empresas" [ngValue]="e.id">{{ e.nome }}</option>
            </select>
            <p *ngIf="carregandoEmpresas" class="texto-carregando-empresas">Carregando empresas...</p>
          </div>
          <button type="button" class="btn-login" (click)="login()">Entrar</button>
        </form>
      </div>
    </div>
  </div>
</div>
